import React from 'react';
import styles from './HeaderLayout.module.scss';
import LanguageSwitcher from '../../logic/components/LanguageSwitcher/LanguageSwitcher';
import ProfileInfo from '../../logic/components/ProfileInfo/ProfileInfo';
import { AuthenticationConsumer } from '../../core/services/AuthenticationProvider';

const HeaderLayout = () => {
    return (
        <AuthenticationConsumer>
            {({ logout }) => (
                <header className={styles.header}>
                    <div className={styles.headerGroup}>
                        <div className={styles.headerItem}>
                            <div className={styles.headerLogo} />
                        </div>
                    </div>

                    <div className={styles.headerGroup}>
                        <div className={`${styles.headerItem} ${styles.headerItemDropdown}`}>
                            <ProfileInfo />
                        </div>

                        <div className={`${styles.headerItem} ${styles.headerItemDropdown}`}>
                            <LanguageSwitcher />
                        </div>

                        <div className={styles.headerItem} onClick={logout}>
                            <i className="fas fa-power-off" />
                        </div>
                    </div>
                </header>)}
        </AuthenticationConsumer>
    )
}

export default HeaderLayout;